module.exports = __webpack_public_path__ + "img/footer_searchArticle-dark.3b18df74.png";